module.exports = __webpack_public_path__ + "static/img/515.44c8c516.jpg";